import PublicBetaNoticePage from './PublicBetaNoticePage';
import { PUBLIC_BETA_NOTICE_LAST_UPDATED } from './publicBetaNoticeContent';

const TermsOfService = () => (
  <PublicBetaNoticePage title="Terms of Service" lastUpdated={PUBLIC_BETA_NOTICE_LAST_UPDATED} />
);

export default TermsOfService;
